import { useState, useRef, useEffect } from "react";
import Label from "lib/Label";
import Image from "lib/Image";
import "./index.scss";
import {Row, Col} from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import Check from "assets/images/checkbox.png";
import Cross from "assets/images/cross.jpg";
import {ReactComponent as OtpEyeOn} from "assets/images/otp-eye-on.svg.svg"
import {ReactComponent as OtpEyeOff} from "assets/images/otp-eye-off.svg"
import { generateOtp, resendOtp } from "api/otpVerification";
import ErrorMessage from "lib/ErrorMessage";
import { FAIL_RESPONSE_LIST, SUCCESS_RESPONSE_LIST } from "constants/api";
import { setOtpValues, setOtpResponse } from "redux/otpReducer";
import { useParams } from "react-router-dom";
import Toast from "components/ToastComponent";
import { Placeholder } from "react-bootstrap";
let currentOtpIndex = 0;

const OTP = (props) => {
 
  const { label, sublabel, onChange, name, value, error, otp_length , masking_type,otp_retries_limit,otp_blocking_time} = props;
  const dispatch = useDispatch();
  const params = useParams();
  const formData = useSelector((state) => state.formData);
  const [message, setMessage] = useState(false);
  const [showMaskedData,setShowMaskedData] = useState(false)
  const [messageToast,setMessageToast] = useState({ type: "", msg: "",position:"",theme:"" });
  const aadharOTPResponse = useSelector((state)=> state.otpReducer.aadharOTPResponse)
  const applicantUserEmail = useSelector(
    (state) => state?.userInfo?.applicantUser?.email
  );
  const validate_email = useSelector((state)=> state?.formData?.selectedData?.validate_email)
  const applicantUserMobileCountryCode = useSelector(
    (state) => state?.userInfo?.applicantUser?.mobile_number_cc
  );
  const applicantUserMobileNumber = useSelector(
    (state) => state?.userInfo?.applicantUser?.mobile_number
  );
  const contactInfo = useSelector(
    (state) => state.otpReducer?.otpValues?.[name]
  );
  const otpValues = useSelector((state) => state.otpReducer?.otpValues);
  const otpResponse = useSelector(
    (state) => state.otpReducer?.otpResponse?.[name]
  );
  const tokenId = useSelector((state) => state.otpReducer?.tokenId?.[name]);
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  const [otp, setOtp] = useState(new Array(otp_length).fill(""));
  const [activeOtpIndex, setActiveOtpIndex] = useState(0);
  const retiresLeft = useSelector(
    (state) => state.otpReducer?.retiresLeft?.[name]
  );
  let subworkflowsData = primaryUser?.source_data?.subworkflows?.find(
    (item) => item.user_id == params?.userId
  );
  // Dup values--
  const workflowUserEmail = useSelector((state) => state?.userInfo?.workflowUser?.subworkflows?.email)
  const workflowUserMobileCountryCode = useSelector(
    (state) => state?.userInfo?.workflowUser?.subworkflows?.mobile_number_cc
  );
  const workflowUserMobileNumber = useSelector(
    (state) => state?.userInfo?.workflowUser?.subworkflows?.mobile_number
  );
  const workflowUser = useSelector( (state) =>state?.userInfo?.workflowUser)
  // --

  useEffect(() => {
    let dispatchObj = {};
    dispatchObj[name] = {};
    dispatch(setOtpResponse({ ...dispatchObj }));
    inputRef?.current?.blur()
    return () =>{
      setOtp(new Array(otp_length).fill(""))
    }
  }, []);

  const parseNumberForWhatsApp = (number) => number.replace('+','').replace("-","")
  useEffect(() => {
    if (name === "email_otp" && applicantUserEmail !== undefined)
      dispatch(setOtpValues({ "email_otp": applicantUserEmail }));
    // Have to add this condition because data in Redux is not consistent
    if (name === "email_otp" && workflowUserEmail !== undefined)
      dispatch(setOtpValues({ "email_otp": workflowUserEmail }));
    //have to add this condition for UAE-Pass manual linking
    if (name === "uaepass_manual_email_otp" && validate_email !==undefined)
      dispatch(setOtpValues({ "uaepass_manual_email_otp": validate_email }));
    if (name === "mobile_otp" && applicantUserMobileNumber !== undefined)
      dispatch(
        setOtpValues({
          "mobile_otp":
            (applicantUserMobileCountryCode
              ? applicantUserMobileCountryCode
              : "") + applicantUserMobileNumber,
        })
      );
    // Have to add this condition because data in Redux is not consistent
      if (name === "mobile_otp" && workflowUserMobileNumber !== undefined)
      dispatch(
        setOtpValues({
          "mobile_otp":
            (workflowUserMobileCountryCode
              ? workflowUserMobileCountryCode
              : "") + workflowUserMobileNumber,
        })
      );
    if (name === "whatsapp_otp" && applicantUserMobileNumber !== undefined) {
      dispatch(
        setOtpValues({
          "whatsapp_otp":
            (applicantUserMobileCountryCode
              ? applicantUserMobileCountryCode
              : "") + parseNumberForWhatsApp(applicantUserMobileNumber),
        })
      );
    }
    // Have to add this condition because data in Redux is not consistent
    if (name === "whatsapp_otp" && workflowUserMobileNumber !== undefined) {
      dispatch(
        setOtpValues({
          "whatsapp_otp":
            (workflowUserMobileCountryCode
              ? workflowUserMobileCountryCode
              : "") + parseNumberForWhatsApp(workflowUserMobileNumber),
        })
      );
    }
    if(name === "aadhaar_otp"){
      dispatch(
        setOtpValues({
          "aadhaar_otp":formData?.selectedData?.aadhaar_number_xml
        })
      );
    }
  }, [applicantUser,formData]); 
  useEffect(() => {
    const isItemPresent = localStorage.getItem(name);
    if(!isItemPresent){
    if (!otpValues.hasOwnProperty(name)) return;
    let recipientName;
    if(applicantUser?.last_name){
      recipientName = applicantUser?.first_name + " " + applicantUser?.last_name
    } else recipientName = applicantUser?.first_name || workflowUser?.subworkflows?.first_name
    const payload = {
      type: "verify",
      otp_mode: name,
      otp_length: otp_length,
      contact_info: contactInfo,
      name: recipientName,
      organisation_id: primaryUser?.organisation_id,
      retiresLeft:retiresLeft,
      application_ref_id: primaryUser?.application_ref_id,
      maximum_retry : otp_retries_limit,
      blocking_duration : otp_blocking_time,
      applicantUser : applicantUser?._id
    };
    if (
      typeof payload.contact_info === "undefined" ||
      payload.contact_info === "undefined" ||
      tokenId
    )
    return;
      dispatch(generateOtp(payload))
      .unwrap()
      .then((result) => {
        if(name == "aadhaar_otp"){
          if(result?.status  == "failed"){
            setMessageToast({ type: "error", msg:"Sorry, OTP delivery was unsuccessful. Please try again.", position: "top-right", theme: "dark" });
          } else if(result?.status == "success"){
            setMessageToast({ type: "success", msg: "OTP successfully generated and sent to your registered mobile number.", position: "top-right", theme: "dark" });
          } else if(result?.status  == "Failed"){
            setMessageToast({ type: "error", msg:result?.message , position: "top-right", theme: "dark" });
          }
          setTimeout(() => {
            setMessageToast(null);
          }, 2000);
        }else{
          if(result?.status  == "Failed"){
            setMessageToast({ type: "error", msg:result?.message , position: "top-right", theme: "dark" });
          }
          setTimeout(() => {
            setMessageToast(null);
          }, 2000);
        }
      });
    }else{
      checkExpiryTime(retiresLeft);
      return;
    }
  }, [otpValues]);

  const inputRef = useRef(0);
  const newOtp = [...otp];
  const newOTP = newOtp.join("");

  const otpFieldChange = (e,idx) => {
    currentOtpIndex=idx
    if (!isNaN(parseInt(e.value)))
      newOtp[idx] = e.value.substring(e.value.length - 1);
    if (
      !(
        newOTP.length === otp_length &&
        SUCCESS_RESPONSE_LIST.includes(otpResponse?.status)
      )
    ) {
      // if (!e.value) setActiveOtpIndex(idx - 1);
      if (
        FAIL_RESPONSE_LIST.includes(otpResponse?.status) &&
        newOTP.length === otp_length
      )
        setActiveOtpIndex(idx + 1);
      else if (!isNaN(parseInt(e.value))) {
        currentOtpIndex++;
        setActiveOtpIndex(idx + 1);
      }
      setOtp(newOtp);
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOtpIndex]);

  useEffect(()=>{
    // Remove Focus when correct otp is entered
    if (SUCCESS_RESPONSE_LIST.includes(otpResponse?.status))
    inputRef.current?.blur()
    },[otpResponse])

  useEffect(() => {
    if (newOTP.length === otp_length) {
      onChange(name, newOTP, otp_retries_limit, otp_blocking_time);
    }
  }, [name, newOTP]);

  useEffect(() => {
    if (value && value?.length) setOtp([...value]);
    inputRef.current?.blur();
  }, [setOtp]);

  const handleKeyDown = (e, index) => {
    currentOtpIndex = index;
    if (!SUCCESS_RESPONSE_LIST.includes(otpResponse?.status)) {
      if (e.key === "Backspace") {
        newOtp[currentOtpIndex] = ''
        setActiveOtpIndex(currentOtpIndex - 1);
        setOtp(newOtp)
      }
    }
  };
  const handlePaste = (idx) => {
    navigator.clipboard.readText().then((clipText) => {
      // filter all Non Number characters form copied text
      clipText = clipText
        .split("")
        .map((each) => {
          if (!isNaN(parseInt(each))) return each;
        })
        .join("");
      let clipIndex = -1;
      let combinedOtp = [
        ...otp.map((each, i) => {
          if (i >= idx && clipText.charAt(clipIndex + 1)) {
            clipIndex++;
            return clipText.charAt(clipIndex);
          } else return each;
        }),
      ];
      while (combinedOtp.length < otp_length) combinedOtp.push("");
      combinedOtp = combinedOtp.splice(0, otp_length);
      setActiveOtpIndex(idx + clipText.length - 1);
      setOtp([...combinedOtp]);
    });
  };

  const setExpiryTime = (retiresLeft, ttl) => {
    const isItemExpired = localStorage.getItem(name);
    if (!isItemExpired) {
      const now = new Date();
      const item = {
        value: retiresLeft,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(name, JSON.stringify(item));
    } else {
      checkExpiryTime(retiresLeft);
      return;
    }
  };

  const checkExpiryTime = (retiresLeft) => {
    const isItemExpired = localStorage.getItem(name);
    if (!isItemExpired) return;
    const item = JSON.parse(isItemExpired);
    const startTime = new Date().getTime(); //current Time
    const timeElapsed = item.expiry - startTime;
    const timeLeft = Math.ceil(timeElapsed / (60 * 1000)); // Convert time to minutes
    if (timeLeft > 0) {
      setMessageToast({
        type: "error",
        msg: `You have exceeded the maximum number of retries. Please try again after ${timeLeft} minutes.`,
        position: "top-right",
        theme: "dark",
      });
      setTimeout(() => {
        setMessageToast(null);
      }, 2000);
    } else {
      localStorage.removeItem(name);
      let recipientName;
      if (applicantUser?.last_name) {
        recipientName =
          applicantUser?.first_name + " " + applicantUser?.last_name;
      } else recipientName = applicantUser?.first_name || workflowUser?.subworkflows?.first_name
      const payload = {
        type: "verify",
        otp_mode: name,
        otp_length: otp_length,
        contact_info: contactInfo,
        name: recipientName,
        organisation_id: primaryUser?.organisation_id,
        retiresLeft: retiresLeft,
        application_ref_id: primaryUser?.application_ref_id,
        maximum_retry: otp_retries_limit,
        blocking_duration: otp_blocking_time,
        applicantUser: applicantUser._id,
      };
      if (
        typeof payload.contact_info === "undefined" ||
        payload.contact_info === "undefined" ||
        tokenId
      )
        return;
      dispatch(generateOtp(payload));
      return null;
    }
    return item.value;
  };

  const resentOTP = (tokenId) => {
    if (!SUCCESS_RESPONSE_LIST.includes(otpResponse?.status)) {
      const isItemExpired = localStorage.getItem(name);
      if (isItemExpired) {
        checkExpiryTime(retiresLeft);
        return;
      }
      if (retiresLeft == 0) {
          setMessageToast({
            type: "error",
            msg: "You have exceeded the maximum number of retries. Please try again after some time.",
            position: "top-right",
            theme: "dark",
          });
          setTimeout(() => {
            setMessageToast(null);
          }, 2000);
          let expiryTime = otp_blocking_time * 60_000
          setExpiryTime(retiresLeft  || 0 , expiryTime);
          return;
        }       
      let data = {
        token_id: tokenId,
        otp_mode:"",
        organisation_id: primaryUser?.organisation_id,
        contact_info:"",
        application_ref_id: primaryUser?.application_ref_id,
        maximum_retry : otp_retries_limit,
        blocking_duration : otp_blocking_time
      };

      if(name == 'aadhaar_otp'){
          data.otp_mode = 'aadhaar_otp';
          data.contact_info = contactInfo
          data.retiresLeft = retiresLeft
      }
      setMessage(true);
      dispatch(resendOtp(data)).unwrap()
      .then((result) => {
        if(result?.status  == "failed"){
          setMessageToast({ type: "error", msg:"The OTP delivery was unsuccessful. Please try again." , position: "top-right", theme: "dark" });
        
        } else if(result?.status == "success"){
          setMessageToast({ type: "success", msg: "OTP has been sent successfully", position: "top-right", theme: "dark" });
        }
        else if(result?.status  == "Failed"){
          setMessageToast({ type: "error", msg:result?.message , position: "top-right", theme: "dark" });
        }
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
       })
      setOtp(new Array(otp_length).fill(""));
      let dispatchObj = {};
      dispatchObj[name] = {};
      dispatch(setOtpResponse({ ...dispatchObj }));
    }
  };

  const timeId = setTimeout(() => {
    // After 3 seconds set the show value to false
    setMessage(false);
  }, 3000);
    
  return (
    <div className="otp-container mt-1">
      <Label label={label} />
      <span>
        {contactInfo ? (
          (name === "aadhaar_otp")?"":contactInfo
        ) : (
          <Placeholder as={"ContactInfo"} animation="glow">
            <Placeholder xs={4} />
          </Placeholder>
        )}
      </span>
      <div className="otp_input d-flex align-items-center">
        {otp.map((data, idx, arr) => {
          return (
            <input
            inputMode='numeric' 
            pattern="[0-9]*"
              type={
                masking_type === "password"
                  ? showMaskedData
                    ? "number"
                    : "password"
                  : "number"
              }
              name={name}
              maxLength="1"
              ref={idx === activeOtpIndex ? inputRef : null}
              key={idx}
              value={data}
              onChange={(e) => otpFieldChange(e.target, idx)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              onFocus={(e) => {
                e.target.select();
                setActiveOtpIndex(idx);
              }}
              onPaste={() => handlePaste(idx)}
            />
          );
        })}

<div className="d-none d-sm-none d-lg-block d-md-block d-flex">
  <Row className="align-items-center d-flex justify-content-center">
    <Col className="p-0">
    {SUCCESS_RESPONSE_LIST.includes(otpResponse?.status) ? (
          // <Image imageSrc={Check} className="verification_image" />
          <span className="d-flex me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check-circle-fill text-theme-primary" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
          </span>
        ) : null}
        {FAIL_RESPONSE_LIST.includes(otpResponse?.status) ? (
          // <Image imageSrc={Cross} className="verification_image" />
          <span className="d-flex me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x text-danger" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </span>
        ) : null}
    </Col>
    <Col className="p-0">
    {masking_type === "password" && (
          <button
            class="bg-transparent border-0 shadow-none mt-2"
            onClick={() => setShowMaskedData(!showMaskedData)}
          >
            {showMaskedData ? (
              <OtpEyeOff className="otp-eye" />
            ) : (
              <OtpEyeOn className="otp-eye" />

            )}
          </button>
        )}
    </Col>
  </Row>
</div>
      </div>
      <div className="d-lg-none d-md-none d-flex align-items-center mt-1">
{SUCCESS_RESPONSE_LIST.includes(otpResponse?.status) ? (
          // <Image imageSrc={Check} className="verification_image" />
          <span className="d-flex me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check-circle-fill text-theme-primary" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
          </span>
        ) : null}
        {FAIL_RESPONSE_LIST.includes(otpResponse?.status) ? (
          // <Image imageSrc={Cross} className="verification_image" />
          <span className="d-flex me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x text-danger" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </span>
        ) : null}
        {masking_type === "password" && (
          <button
            class="bg-transparent border-0 shadow-none mt-2"
            onClick={() => setShowMaskedData(!showMaskedData)}
          >
            {showMaskedData ? (
              <OtpEyeOff className="otp-eye" />
            ) : (
              <OtpEyeOn className="otp-eye" />
            )}
          </button>
        )}
</div>
      {otpResponse?.name?.status == "Failed" && (
        <p className="mt-3 red">
          Incorrect OTP
          <span className="resend" onClick={() => resentOTP(tokenId)}>
            Resend
          </span>
        </p>
      )}
      {!(otpResponse?.name?.status == "Failed") && (
        <p className="mt-3">
          Didn't get code?
          <span
            style={{ marginLeft: "5px" }}
            className={
              !SUCCESS_RESPONSE_LIST.includes(otpResponse?.status)
                ? retiresLeft === 0
                  ? "resend-disabled"
                  : "resend"
                : "resend-disabled"
            }
            onClick={() => resentOTP(tokenId)}
          >
            Resend
          </span>
          {retiresLeft >= 0 ? (
            <span style={{ color: "black" }}>
              {" "}
              (Retries left : {retiresLeft})
            </span>
          ) : null}
        </p>
      )}
      {error && error.length !== 0 && <ErrorMessage error={error} />}
      {messageToast?.msg && (
        <Toast
          message={messageToast.msg}
          type={messageToast.type}
          position={messageToast.position}
          theme={messageToast.theme}
        />
      )}
    </div>
  );
};





export default OTP;
